<template>
  <b-card header="Image masking" class="mb-4">
    <b-row>
      <b-col>Original</b-col>
      <b-col>Masked</b-col>
    </b-row>

    <b-row style="transition:filter 2s ease-in-out">
      <b-col>
        <b-img fluid :src="originalURI" :class="{hide:!original}"/>
      </b-col>
      <b-col>
        <b-img fluid :src="maskedURI"  :class="{hide:!masked}"/>
      </b-col>
    </b-row>
    <b-form-group
      label="Tolerance"
      description="Tolerance to near-match colours"
      class="mt-2"
      label-cols="2"
      label-align="right"
    >
      <b-form-input type="range" v-model="fuzz" min="0" max="100" @change="onFuzzChange()" />
      {{fuzz}}
    </b-form-group>
    <b-form-group
      label="Background colour"
      description="Background colour to remove"
      class="mt-2"
      label-cols="2"
      label-align="right"
    >
      <b-form-input type="color" v-model="colour" @change="onFuzzChange()"/>
      {{colour}}
    </b-form-group>

  </b-card>
</template>

<script>
import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.FormGroupPlugin,
    bs.FormInputPlugin,
    bs.CardPlugin,
    bs.ImagePlugin,
].forEach(p=> Vue.use(p))
export default {
  props: ["image", "value"],
  data() {
    return {
      fuzz: 10,
      colour: '#000000',
      originalURI: null,
      maskedURI: null,
      reduced: null,
      original:false,
      masked:false,
    };
  },
  async mounted() {
    this.onImageChange()
  },
  computed: {
      args(){
          return `-fuzz ${this.fuzz}% -fill #f0f -floodfill +0+0 ${this.colour} -quality 100`
      },
    cmd() {
      return `convert ${this.image.name} ${this.args} out.jpg`;
    }
  },
  watch: {
    image() {
      this.$nextTick(this.onImageChange);
    }
  },
  methods: {
    async onImageChange() {
      let self = this;
      self.original = false;
      self.masked = false;

      let image = {
        name: this.image.name,
        content: await this.image.arrayBuffer()
      };
      //Magick is loaded as module via script tag in index.html
        // eslint-disable-next-line
      let small = await Magick.Call(
        [image],
        `mogrify -resize 12.5% ${this.image.name}`.split(" ")
      );
      this.reduced = small[0];

      const reader = new FileReader();
      reader.onloadend = () => {
        self.originalURI = reader.result;
        self.original = true;
        this.onFuzzChange();
      };
      reader.readAsDataURL(this.reduced.blob);
    },
    async onFuzzChange() {
      let image = {
        name: this.image.name,
        content: await this.reduced.blob.arrayBuffer()
      };
      this.masked = false;
      let thisFuzz = this.fuzz;
      //Magick is loaded as module via script tag in index.html
      // eslint-disable-next-line
      let job = await Magick.Call([image], this.cmd.split(" "));
      let self = this;
      const reader = new FileReader();
      reader.onloadend = () => {
        if (self.fuzz == thisFuzz) {
            self.maskedURI = reader.result;
            self.masked = true;    
        }
      };
      reader.readAsDataURL(job[0].blob);
      this.$emit('input', this.args)
    }
  }
};
</script>

<style>
.hide{
    filter: blur(3px);
}
</style>